<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div (window:resize)="onWindowResize($event)" *ngIf="payload?.properties">
  <div *ngIf="payload.properties.text?.value">
    <!-- <label class="flex jcc">
            <span>
                {{payload?.properties?.text?.value}}
                <span class="required" *ngIf="payload?.required">*</span>
            </span>
        </label> -->
    <label class="flex jcc">
      <span>
        <span [innerHTML]="payload.properties.text?.value | tokenToDiv"></span>
        <span class="required" *ngIf="payload.properties.required.value">*</span>
      </span>
    </label>
  </div>
  <div class="label-container" *ngIf="payload.properties.content?.value">
    <label class="flex jcc subtitle">
      <span>
        <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
        <span class="required" *ngIf="!payload.properties.text?.value && payload.properties.required.value"> * </span>
      </span>
    </label>
  </div>
  <div class="attachment rel">
    <div class="thumbnail-preview">
      <rx-icon class="spinner" name="icon-spinner" *ngIf="busy"></rx-icon>
      <ng-container *ngFor="let image of images">
        <div class="thumbnail-preview__container" [style.maxWidth.px]="hostWidth / 2" *ngIf="image?.base64">
          <img
            [src]="image.base64"
            (click)="onAttachedImageClicked($event, image)"
            (load)="onImageLoad($event, image)"
            (error)="onImageLoadError($event, image)"
          />
          <div *ngIf="canRemoveImage()" class="removeImage" (click)="onRemoveImageClick($event, image)">x</div>
        </div>
      </ng-container>
    </div>

    <div class="attachement__content" *ngIf="images.length === 0 && !busy">
      <ng-container [ngSwitch]="getTemplateMode()">
        <ng-container
          *ngSwitchCase="templateMode.MobileProvider"
          [ngTemplateOutlet]="mobileProviderTemplate"
        ></ng-container>
        <ng-container *ngSwitchCase="templateMode.MobileKiosk" [ngTemplateOutlet]="mobileKioskTemplate"></ng-container>
        <ng-container *ngSwitchCase="templateMode.RxPortal" [ngTemplateOutlet]="rxPortalTemplate"></ng-container>
        <ng-container *ngSwitchCase="templateMode.Web" [ngTemplateOutlet]="webTemplate"></ng-container>
        <ng-container *ngSwitchCase="templateMode.Printing" [ngTemplateOutlet]="printingTemplate"></ng-container>
        <ng-container *ngSwitchCase="templateMode.Custom" [ngTemplateOutlet]="customTemplate"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="webTemplate"></ng-container>
      </ng-container>
    </div>
  </div>
  <div
    *ngIf="payload.properties.hint?.value"
    class="hint"
    [innerHTML]="payload.properties.hint?.value | tokenToDiv"
  ></div>
  <div *ngIf="payload.properties.required.value && isSubmitted && !isValid()" class="hint-required">
    This field is required
  </div>
</div>

<!-- Mobile Provider Template -->

<ng-template #mobileProviderTemplate>
  <button [matMenuTriggerFor]="addAttachmentMenu">Add Attachment</button>

  <mat-menu #addAttachmentMenu class="form-menu">
    <ng-template matMenuContent>
      <button mat-menu-item (click)="onClientPhotosClicked($event)">
        <rx-button class="text-large">Client Photos</rx-button>
      </button>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="onBrowseClicked($event)">
        <rx-button class="text-large">Browse</rx-button>
      </button>
    </ng-template>
  </mat-menu>
</ng-template>

<!-- Mobile Kiosk Template -->

<ng-template #mobileKioskTemplate>
  <div class="flex flex-nosize">
    <button (click)="handleKioskModeAttachment($event)">Add Attachment</button>
  </div>
</ng-template>

<!-- Web Template -->

<ng-template #webTemplate>
  <div class="flex flex-nosize">
    <button (click)="onBrowseClicked($event)">Add Attachment</button>
  </div>
</ng-template>

<!-- RxPortal Template -->

<ng-template #rxPortalTemplate>
  <div class="flex flex-nosize">
    <button (click)="onBrowseClicked($event)">Add Attachment</button>
  </div>
</ng-template>

<!-- Printing Template -->

<ng-template #printingTemplate>
  <div>No attachment</div>
</ng-template>

<!-- TODO: Provide custom UI for Attachment -->

<ng-template #customTemplate></ng-template>
